<template>
    <div class="scroll_chart">
      <div class="flex_div">
        <div>
          <div class="left_top">{{stepTitle}}</div>
          <div >
            <span  class="bottom_big">{{totalStep}}</span><span class="bottom_small">步</span>
          </div>
        </div>
        <div>{{stepSection}}</div>
      </div>
      <div ref="chartContainer"></div>
    </div>
  </template>
  
  <script>
  import Highcharts from 'highcharts';
  import HCMore from 'highcharts/highcharts-more';
  import HCExporting from 'highcharts/modules/exporting';
  import Hammer from 'hammerjs';
  import {getStepDataDetail} from "@/api/api.report";
  HCMore(Highcharts);
  HCExporting(Highcharts);
  
  export default {
    name: 'SlideChart',
    props: {
      valueType: {
        type: String,
        required: true
      },
    },
    watch:{
      valueType(val){
        this.pageNo=1
        
        this.updateChartData()
      }
    },
    created(){
      if(this.valueType==1){
        this.stepValue=5
      }else if(this.valueType==2){
        this.stepValue=1
      }
      else if(this.valueType==3){
        this.stepValue=4
      }else{
        this.stepValue=1
      }
      this.getChartData()
    },
    mounted() {
      const mc = new Hammer.Manager(this.$refs.chartContainer);
      const pan = new Hammer.Pan({ direction: Hammer.DIRECTION_ALL });
      mc.add(pan);
  
      let startX = 0;
      let startY = 0;
  
      mc.on('panstart', (event) => {
        startX = event.center.x;
        startY = event.center.y;
      });
  
      mc.on('panend', (event) => {
        const endX = event.center.x;
        const endY = event.center.y;
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        const threshold = 30; // 滑动距离阈值
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > threshold) { // 判断是否为左右滑动事件且距离超过阈值
          if (deltaX > 0) {
            this.slideRight(); // 向右滑动刷新数据
          } else {
            this.slideLeft(); // 向左滑动刷新数据
          }
          event.preventDefault();
        }
      });
      
      
    },
    data() {
      return {
        stepValue:1,
        chart: null,
        stepSection:'',
        timeInterval:{startDate:'res.result.startDate',endDate:''},
        start: 0,
        end: 7,
        pageNo:1,
        totalStep:0,
        stepTitle:"总步数",
        nowYears:"",
        nowWeek:"",
        nowTotalStep:'',
        data: [29.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.2,9.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4],
        categories: ['6.1','6.2','6.3','6.4','6.5','6.6','6.7','6.8','6.9','6.10','6.11','6.12','6.13','6.14','6.15', '6.16','6.17','6.18','6.19','6.20','6.21','6.22','6.23','6.24','6.25','6.26','6.27','6.27','6.28','6.29','6.30',]
      };
    },
    methods: {
      getChartData(){
        getStepDataDetail({studentId:this.loginUser.studentId,type:this.valueType,pageNo:this.pageNo}).then((res)=>{
          this.valueType!=1?this.stepTitle="日均步数":this.stepTitle="总步数"
          this.data=[]
          this.categories=[]
          let sunData=['周一','周二','周三','周四','周五','周六','周七',]
          res.result.list.forEach((l)=>{
            this.data.push(l.step)
            if(this.valueType!=2){
              this.categories.push(l.section)
            }
          })
          this.nowWeek=res.result.list
          if(this.valueType==2){
            this.categories=sunData
            this.stepSection=res.result.startDate+'至'+res.result.endDate
          this.nowYears=res.result.startDate+'至'+res.result.endDate

          }else{
            this.stepSection=res.result.stepSection
          this.nowYears=res.result.stepSection


          }
          // this.timeInterval={startDate:res.result.startDate,endDate:res.result.endDate}
          this.valueType!=1?this.totalStep=res.result.avgStep || 0:this.totalStep=res.result.totalStep || 0
          this.valueType!=1?this.nowTotalStep=res.result.avgStep || 0:this.nowTotalStep=res.result.totalStep || 0
          this.initChart();
        })
      },
      updateChartData(){
        if(this.valueType==1){
          this.stepValue=5
        }else if(this.valueType==2){
          this.stepValue=1
        }
        else if(this.valueType==3){
          this.stepValue=4
        }else{
          this.stepValue=1
        }
        let sunData=['周一','周二','周三','周四','周五','周六','周日',]

        getStepDataDetail({studentId:this.loginUser.studentId,type:this.valueType,pageNo:this.pageNo}).then((res)=>{
          this.valueType!=1?this.stepTitle="日均步数":this.stepTitle="总步数"
          this.data=[]
          this.categories=[]
          res.result.list.forEach((l)=>{
            this.data.push(l.step)
            if(this.valueType!=2){
              this.categories.push(l.section)
            }
          })
          this.nowWeek=res.result.list
          if(this.valueType==2){
            this.categories=sunData
            this.stepSection=res.result.startDate+'至'+res.result.endDate
          this.nowYears=res.result.startDate+'至'+res.result.endDate

          }else{
            this.stepSection=res.result.stepSection
            this.nowYears=res.result.stepSection

          }
          // this.timeInterval={startDate:res.result.startDate,endDate:res.result.endDate}
          this.valueType!=1?this.totalStep=res.result.avgStep || 0:this.totalStep=res.result.totalStep || 0
          this.valueType!=1?this.nowTotalStep=res.result.avgStep || 0:this.nowTotalStep=res.result.totalStep || 0

          this.chart.update({
              xAxis: {
                categories: this.categories,
                labels:{
                  step:this.stepValue
                },
                startOnTick: true 
              },
              series: [{
                data: this.data
              }]
            });
        })
      },
      initChart() {
        const _this=this
        this.chart = Highcharts.chart(this.$refs.chartContainer, {
          chart: {
            type: 'column',
            height:300,
            backgroundColor:"#F1F7FF",
            borderRadius:8,
            events: {
              click: function(val) {
                  var chart = this;
                  var x = val.pageX - _this.$refs.chartContainer.offsetLeft-50;
                  // var y = val.pageY - _this.$refs.chartContainer.offsetTop;
                  // var closestDistance = Infinity;
                  var closestPoint = null;
                  var tempNum=Infinity
                  chart.series.forEach(function(series) {
                    series.points.forEach(function(point) {
                      // var distance = Math.sqrt(Math.pow(point.plotX - x, 2) + Math.pow(point.plotY - y, 2));
                      var distance=Math.abs(point.plotX-x)
                      if(tempNum>distance){
                        tempNum=distance
                        closestPoint = point;
                      }
                      // console.log("distance",distance);
                      // if (distance < closestDistance) {
                      //   closestDistance = distance;
                      //   closestPoint = point;
                      // }
                    });
                  });
                  if (closestPoint) {
                      if(!closestPoint.selected){
                        if(_this.valueType==4){
                          _this.stepSection=_this.nowYears+'年'+closestPoint.category+'月'
                        }else if(_this.valueType==2){
                          let selectIndex=_this.categories.findIndex((f)=>{
                            return f==closestPoint.category
                          })
                          console.log(_this.nowWeek[selectIndex].date);
                          
                          _this.stepSection=_this.nowWeek[selectIndex].date
                        }else if(_this.valueType==1){
                          let selectIndex=_this.categories.findIndex((f)=>{
                            return f==closestPoint.category
                          })
                          
                          _this.stepSection=_this.nowYears+"  "+_this.nowWeek[selectIndex].section
                        }else if(_this.valueType==3){
                          let selectIndex=_this.categories.findIndex((f)=>{
                            return f==closestPoint.category
                          })
                          
                          _this.stepSection=_this.nowYears+"-"+_this.nowWeek[selectIndex].section.split("/")[1]
                        }
                        
                        _this.totalStep=closestPoint.options.y
                        _this.stepTitle="总步数"
                        console.log(_this.$refs.chartContainer.offsetTop);
                      }else{
                        _this.stepSection=_this.nowYears
                        if(_this.valueType!=1){_this.stepTitle="日均步数"}
                        _this.totalStep=_this.nowTotalStep
                      }
                      closestPoint.select();
                  }
              }
            }
          },
          legend:false,
          // tooltip: {
          //   pointFormat: `{series.name}: <b>{point}</b>`
          // },
          tooltip:false,
          title: {
            text: ''
          },
          xAxis: {
            min:0,
            // .slice(this.start, this.end)
            categories: this.categories,
            labels:{
              step:this.stepValue
            }
          },
          yAxis: {
            min: 0,
            minRange: 1000,
            title: {
              text: ''
            },
            gridLineColor: 'transparent'
          },
          series: [{
            // .slice(this.start, this.end)
            color:'#1677FF',
            allowPointSelect: true,
            borderRadius: 5,  //这里设置  一共四个属性 这里就设置2个 也就是上边是圆形的 下边不变  如果想下边变得话 设置其他两个属性就行了  
            data: this.data,
            states: {
              select: {
                color: '#1677FF' // 设置选中时的颜色
              }
            },
            point: {
              events: {
                click: function (val) {
                  if(!val.point.selected){
                    if(_this.valueType==4){
                      _this.stepSection=_this.nowYears+'年'+val.point.category+'月'
                    }else if(_this.valueType==2){
                      let selectIndex=_this.categories.findIndex((f)=>{
                        return f==val.point.category
                      })
                      
                      _this.stepSection=_this.nowWeek[selectIndex].date
                    }else if(_this.valueType==1){
                      let selectIndex=_this.categories.findIndex((f)=>{
                        return f==val.point.category
                      })
                      
                      _this.stepSection=_this.nowYears+"  "+_this.nowWeek[selectIndex].section
                    }else if(_this.valueType==3){
                      let selectIndex=_this.categories.findIndex((f)=>{
                        return f==val.point.category
                      })
                      
                      _this.stepSection=_this.nowYears+"-"+_this.nowWeek[selectIndex].section.split("/")[1]
                    }
                    
                    _this.totalStep=val.point.options.y
                    _this.stepTitle="总步数"
                  }else{
                    _this.stepSection=_this.nowYears
                    if(_this.valueType!=1){
                      _this.stepTitle="日均步数"}
                    _this.totalStep=_this.nowTotalStep
                  }

                  
                }
              }
            }
          }],
          credits: false,
          exporting: {
            enabled: false
          }
        });
      },
      slideRight() {
        this.pageNo+=1
        this.updateChartData()
        this.deselectAllPoints()
        // this.isRefreshing = true;
        // setTimeout(() => {
        //   if (this.start > 0) {
        //     this.start -= 1;
        //     this.end -= 1;
        //     const newSeriesData = this.data.slice(this.start, this.end);
        //     const newCategories = this.categories.slice(this.start, this.end);
        //     this.chart.update({
        //       xAxis: {
        //         categories: newCategories
        //       },
        //       series: [{
        //         data: newSeriesData
        //       }]
        //     });
        //   }
        //   this.isRefreshing = false;
        // }, 1000);
      },
      slideLeft() {
        if(this.pageNo>1){
          this.pageNo-=1
          this.updateChartData()
        }
        this.deselectAllPoints()
        // this.isRefreshing = true;
        // setTimeout(() => {
        //   if (this.end < this.data.length) {
        //     this.start += 1;
        //     this.end += 1;
        //     const newSeriesData = this.data.slice(this.start, this.end);
        //     const newCategories = this.categories.slice(this.start, this.end);
        //     this.chart.update({
        //       xAxis: {
        //         categories: newCategories
        //       },
        //       series: [{
        //         data: newSeriesData
        //       }]
        //     });
        //   }
        //   this.isRefreshing = false;
        // }, 1000);
      },
      deselectAllPoints() {
        let selectedPoints = this.chart.getSelectedPoints();
        selectedPoints.forEach(function(point) {
          point.select(false, true);
        });
      }
 
    }
  };
  </script>
  <style lang="scss">
    .scroll_chart{
      width: 100%;
      margin: 0.05rem 0;
      padding: 0 0.12rem;
      .flex_div{
        display: flex;
        justify-content: space-between;
        .left_top{
          font-size: 0.12rem;
          font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
          font-weight: 400;
          color: #000000;
          margin-bottom: 0.1rem;
        }
        .bottom_big{
          font-size: 0.24rem;
          font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
          font-weight: 600;
          color: #000000;
          margin-right: 0.05rem;
        }
        .bottom_small{
          font-size: 0.1rem;
          font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
          font-weight: 400;
          color: #000000;
          opacity: 0.6;
          margin-bottom: 0.6rem;
        }
      }
    }
  </style>